exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CWlEzXzVfCmr3cddkexUp{color:#d83b01}._2pcroTqbZYK69mljlKUy76{color:#107c10}._2LV6NqLjtr1o4TA0pBTuEo{font-size:14px}html[dir=ltr] ._2LV6NqLjtr1o4TA0pBTuEo{margin-right:4px}html[dir=rtl] ._2LV6NqLjtr1o4TA0pBTuEo{margin-left:4px}._2bU8_Vdm2HXp4M_3yWofgD{height:18px;width:18px}html[dir] ._2bU8_Vdm2HXp4M_3yWofgD.ms-Button{padding:0}._2bU8_Vdm2HXp4M_3yWofgD.ms-Button .ms-Button-icon{font-size:14px}html[dir] ._2bU8_Vdm2HXp4M_3yWofgD.ms-Button .ms-Button-icon{margin:0}", ""]);

// exports
exports.locals = {
	"error": "CWlEzXzVfCmr3cddkexUp",
	"checkmark": "_2pcroTqbZYK69mljlKUy76",
	"leftIcon": "_2LV6NqLjtr1o4TA0pBTuEo",
	"rightIcon": "_2bU8_Vdm2HXp4M_3yWofgD"
};